/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {ChangePassword} from './ChangePassword'
import {Tabs} from 'antd'
import {UserModel} from '../../../modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {ChangeEmail} from './ChangeEmail'

const {TabPane} = Tabs

const DisplaySetting: FC = () => {
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  return (
    <div>
      <div style={{marginBottom: '30px'}}>
        <ChangePassword />
      </div>

      <div style={{marginBottom: '30px'}}>
        <ChangeEmail />
      </div>
    </div>
  )
}

export {DisplaySetting}
